import { render, staticRenderFns } from "./bigEgvent.vue?vue&type=template&id=6dddc46b&scoped=true&"
import script from "./bigEgvent.vue?vue&type=script&lang=js&"
export * from "./bigEgvent.vue?vue&type=script&lang=js&"
import style0 from "./bigEgvent.vue?vue&type=style&index=0&id=6dddc46b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dddc46b",
  null
  
)

export default component.exports